import { render } from "./FormSearchDiscount.vue?vue&type=template&id=6ba29245&scoped=true"
import script from "./FormSearchDiscount.vue?vue&type=script&lang=js"
export * from "./FormSearchDiscount.vue?vue&type=script&lang=js"

import "./FormSearchDiscount.vue?vue&type=style&index=0&id=6ba29245&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba29245"]])

export default __exports__